import {
	JIRASERVICEMANAGEMENT,
	type Solutions,
} from '@jira/platform__common-constants/src/solutions-types.tsx';
import getApplicationSubProduct from '../get-application-sub-product/getApplicationSubProduct.tsx';

const getApplicationSolutions = (): Solutions[] | undefined =>
	getApplicationSubProduct() === 'serviceDesk' ? [JIRASERVICEMANAGEMENT] : undefined;

export default getApplicationSolutions;
